module.exports = __webpack_public_path__ + "img/lender_signup_hero_mobile.c20b3930.jpg";